export default __webpack_public_path__ + "static/media/cihr.dcfe5b30.png";